import React from 'react';
import Button from '../Buttons/Button';
import {appText} from '../../assets/text/appText';
import styles from './SubscriptionPlanCard.module.css';
import {
  chooseAnnualSubscription,
  chooseMonthlySubscription,
  fixSubscriptionIdForAnnual,
  isAnnualSubscription,
  SUBSCRIPTION_ENTERPRISE,
} from '../../pages/Subscription/config';
import {SubscriptionPlan} from '../../pages/Settings/SubscriptionSettings/config';

interface Props {
  onClick: (tier?: number) => void;
  onShowFullList: () => void;
  plan: SubscriptionPlan;
  isCurrentPlan?: boolean;
  expired?: boolean;
  isEnterprise: boolean;
  currentSubscriptionId: number;
  isAnnualView: boolean;
}

const SubscriptionPlanCard = React.memo(
  ({
    onClick,
    onShowFullList,
    plan,
    isCurrentPlan,
    expired,
    isEnterprise,
    currentSubscriptionId,
    isAnnualView,
  }: Props) => {
    const disableChangeFromAnnualToMonthly =
      isAnnualSubscription(currentSubscriptionId) &&
      !isAnnualView &&
      !isEnterprise;

    const planFeatures = isAnnualView
      ? plan.featuresAnnual
      : plan.featuresMonthly;

    const isEnterprisePlan =
      Boolean(isEnterprise) ||
      plan.id === SUBSCRIPTION_ENTERPRISE ||
      (plan as any).isEnterprise === true;

    return (
      <div className={styles.wrapper}>
        <h3 className={styles.title}>{plan.title}</h3>
        <h2 className={styles.price}>
          {isAnnualView ? plan.priceAnnual : plan.priceMonthly}
          {!isEnterprisePlan && <span>{isAnnualView ? '/year' : '/mo'}</span>}
        </h2>
        {planFeatures.length > 0 && (
          <ul className={styles.features}>
            {planFeatures.map((item, index) => (
              <li key={index}>
                <span className="icon-typeCheck"></span>
                {item}
              </li>
            ))}
          </ul>
        )}
        {plan.specialText && (
          <p className={styles.specialText}>{plan.specialText}</p>
        )}
        {isCurrentPlan &&
          isAnnualView === isAnnualSubscription(currentSubscriptionId) && (
            <div className={styles.subscription_button_container}>
              <Button
                title={appText.currentPlan}
                disabled={true}
                uiType="tapybl_generic"
                className={styles.subscription_button}
                onClick={() => {
                  /*nothing*/
                }}
              />
              {expired && (
                <Button
                  title={appText.renew}
                  onClick={() =>
                    onClick
                      ? onClick(
                          isAnnualView
                            ? chooseAnnualSubscription(plan.id)
                            : chooseMonthlySubscription(plan.id),
                        )
                      : () => {
                          //noting
                        }
                  }
                  uiType="tapybl_generic"
                  className={styles.subscription_button}
                />
              )}
            </div>
          )}
        {(!isCurrentPlan ||
          isAnnualView !== isAnnualSubscription(currentSubscriptionId) ||
          isEnterprise) &&
          !disableChangeFromAnnualToMonthly && (
            <div className={styles.subscription_button_container}>
              <Button
                title={plan.buttonText}
                onClick={() =>
                  onClick(fixSubscriptionIdForAnnual(plan.id, isAnnualView))
                }
                uiType="tapybl_generic"
                className={styles.subscription_button}
              />
            </div>
          )}
        {plan.cancelAnytime && (
          <p className={styles.cancelAnytime}>{appText.cancelAnytime}</p>
        )}
        {plan.showDetails && (
          <>
            <p className={styles.moreDetails}>
              {appText.showDetails}
              <span onClick={onShowFullList} className={styles.pseudoLink}>
                {appText.clickHere}
              </span>
            </p>
          </>
        )}
      </div>
    );
  },
);

export default SubscriptionPlanCard;
